import { apiGet, apiPost } from './api';

export interface AccountInfo {
  id: string;
  userNum: number;
  email: string;
  userName: string;
  isGM: boolean;
  isGML: boolean;
  needVerify: boolean;          // legado — nao usar pra badge VERIFICADO
  cellphone?: string | null;
  cellphone_Id?: number | null;
  isCellphoneVerified: boolean; // fonte da verdade do badge VERIFICADO
  playTime?: number;
  login?: number;
  authType?: number;
  lastIp?: string | null;
  createDate?: string;
  loginTime?: string | null;
  logoutTime?: string | null;
  // Metadata extra (Informacoes da Conta — vem do /Account/get)
  createdAt?: string | null;
  lastLoginAt?: string | null;
  characterCount?: number | null;
}

export interface PremiumInfo {
  userNum: number;
  serviceKind: number;
  expireDate: string;
}

/** GET /Account/get — dados da conta logada */
export const getAccount = () => apiGet<AccountInfo>('/Account/get');

/** GET /Account/premium — status premium */
export const getPremium = () => apiGet<PremiumInfo>('/Account/premium');

/** GET /Account/resetSub — resetar sub password */
export const resetSub = (password: string) =>
  apiGet<{ status: string; message: string }>('/Account/resetSub', { password });

/** GET /Account/newpassword — solicitar reset de senha por email */
export const requestNewPassword = (id: string) =>
  apiGet<{ status: string; message: string }>('/Account/newpassword', { id });

/** GET /Account/changepassword — alterar senha via link */
export const changePassword = (key: string, password: string) =>
  apiGet<{ status: string; message: string }>('/Account/changepassword', { key, password });

/** POST /Account/linkCellphone/send — manda SMS pro celular informado (autenticado) */
export const linkCellphoneSend = (cellphone: string) =>
  apiPost<{ status: string; message: string }>('/Account/linkCellphone/send', { Cellphone: cellphone });

/** POST /Account/linkCellphone/verify — valida codigo e vincula */
export const linkCellphoneVerify = (cellphone: string, code: string) =>
  apiPost<{ status: string; message: string }>(
    '/Account/linkCellphone/verify',
    { Cellphone: cellphone, Code: code },
  );
